// eslint-disable-next-line import/prefer-default-export
import { ppn } from '@/constants/tax'
import { IDR } from '@/libs/currency'
import { DAY_MONTH_YEAR, LABEL_MONTH_YEAR } from '@/libs/filterDate'

export const tableActive = [
  {
    key: 'id',
    label: 'ID',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black',
  },
  {
    key: 'partner_name',
    label: 'Nama partner',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black',
  },
  {
    key: 'invoice_code',
    label: 'No Invoice',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black',
  },
  {
    key: 'invoice_paid',
    label: 'Invoice Terbayar',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black',
  },
  {
    key: 'nominal',
    label: 'Nominal',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
      textAlign: 'center',
    },
    tdClass: 'text-black',
    formatter: value => IDR(value),
  },
  {
    key: 'additional_cost',
    label: 'Biaya Lainnya',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
      textAlign: 'center',
    },
    tdClass: 'text-black',
    formatter: value => IDR(value),
  },
  {
    key: 'published',
    label: 'Published',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      textAlign: 'center',
      padding: '12px 7px',
      width: '80px',
    },
    tdClass: 'text-black text-center',
  },
  {
    key: 'paid',
    label: 'Paid',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      textAlign: 'center',
      padding: '12px 7px',
      width: '80px',
    },
    tdClass: 'text-black text-center',
  },
  {
    key: 'action',
    label: 'Aksi',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      textAlign: 'center',
      padding: '12px 7px',
    },
    tdClass: 'text-black text-center',
  },
]

export const tableHistory = [
  {
    key: 'id',
    label: 'No',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black',
  },
  {
    key: 'partner_name',
    label: 'Nama partner',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black',
  },
  {
    key: 'invoice_code',
    label: 'No Invoice',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black',
  },
  {
    key: 'payment_date',
    label: 'Tanggal Pembayaran',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black',
    formatter: value => DAY_MONTH_YEAR(value),
  },
  {
    key: 'nominal',
    label: 'Nominal',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
      textAlign: 'center',
    },
    tdClass: 'text-black',
    formatter: value => IDR(value),
  },
  {
    key: 'paid',
    label: 'Paid',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      textAlign: 'center',
      padding: '12px 7px',
      width: '80px',
    },
    tdClass: 'text-black text-center',
  },
  {
    key: 'action',
    label: 'Aksi',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      textAlign: 'center',
      padding: '12px 7px',
    },
    tdClass: 'text-black text-center',
  },
]

export const tableTalent = [
  {
    key: 'id',
    label: 'No',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black align-top !py-[9px]',
  },
  {
    key: 'talent_name',
    label: 'Nama Talent',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black align-top !py-[9px]',
  },
  {
    key: 'admin_fee',
    label: 'Biaya Admin',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black align-top !py-[9px]',
  },
  {
    key: 'discount',
    label: 'Diskon',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      width: '50px',
      padding: '12px 7px',
    },
    tdClass: 'text-black align-top !py-[9px]',
  },
  {
    key: 'talent_salary',
    label: 'Gaji Talent',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
      width: '150px',
    },
    tdClass: 'text-black align-top !py-[9px]',
  },
  {
    key: 'additional_cost',
    label: 'Biaya Lainnya',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
      width: '150px',
    },
    tdClass: 'text-black align-top !py-[9px]',
  },
  {
    key: 'total',
    label: 'Total',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
      width: '120px',
    },
    tdClass: 'text-black align-top !py-[9px]',
    formatter: (value, key, item) => {
      const finalAdminFee = item.admin_fee - (item.admin_fee * (item.discount / 100))
      const total = finalAdminFee + item.talent_salary + item.additional_cost
      return IDR(total)
    },
  },
  {
    key: 'action',
    label: '',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black align-top !py-[9px]',
  },
]

export const tableDisbursement = [
  {
    key: 'id',
    label: 'ID',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black !py-[9px]',
  },
  {
    key: 'talent_name',
    label: 'Nama Talent',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black !py-[9px]',
  },
  {
    key: 'admin_fee',
    label: 'Biaya Admin',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black !py-[9px]',
    formatter: value => IDR(value),
  },
  {
    key: 'discount',
    label: 'Diskon',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black !py-[9px]',
  },
  {
    key: 'talent_salary',
    label: 'Gaji Talent',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black !py-[9px]',
    formatter: value => IDR(value),
  },
  {
    key: 'additional_cost',
    label: 'Biaya Lainnya',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black !py-[9px]',
  },
  {
    key: 'sharing_fee',
    label: 'Sharing Fee',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black !py-[9px]',
    formatter: value => (value <= 100 ? `${value}%` : IDR(value)),
  },
  {
    key: 'app_fee',
    label: 'Biaya aplikasi',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black !py-[9px]',
    formatter: () => IDR(5500),
  },
  {
    key: 'total',
    label: 'Total',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black !py-[9px]',
    formatter: (value, key, item) => {
      const finalAdminFee = item.admin_fee - (item.admin_fee * (item.discount / 100))
      const total = finalAdminFee + item.talent_salary + item.additional_cost + item.application_fee
      return IDR(total)
    },
  },
]

export const tableDetailHistory = [
  {
    key: 'id',
    label: 'No',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black !py-[9px]',
  },
  {
    key: 'talent_name',
    label: 'Nama Talent',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black !py-[9px]',
  },
  {
    key: 'admin_fee',
    label: 'Biaya Admin',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black !py-[9px]',
    formatter: value => IDR(value),
  },
  {
    key: 'talent_salary',
    label: 'Gaji Talent',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black !py-[9px]',
    formatter: value => IDR(value),
  },
  {
    key: 'additional_cost',
    label: 'Biaya Lainnya',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black !py-[9px]',
  },
  {
    key: 'total',
    label: 'Total',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black !py-[9px]',
    formatter: (value, key, item) => {
      const finalAdminFee = item.admin_fee - (item.admin_fee * (item.discount / 100))
      const total = finalAdminFee + item.talent_salary + item.additional_cost
      return IDR(total)
    },
  },
  {
    key: 'status',
    label: 'Status Disbursement',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black !py-[9px]',
  },
]

export const tableMonitor = [
  {
    key: 'id',
    label: 'ID',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
    },
    tdClass: 'text-black !py-[9px]',
  },
  {
    key: 'talent_name',
    label: 'Nama Talent',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
    },
    tdClass: 'text-black !py-[9px]',
  },
  {
    key: 'admin_fee',
    label: 'Biaya Admin',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
    },
    tdClass: 'text-black !py-[9px]',
    formatter: value => IDR(value),
  },
  {
    key: 'talent_salary',
    label: 'Gaji Talent',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
    },
    tdClass: 'text-black [&>*]:whitespace-nowrap',
  },
  {
    key: 'additional_cost',
    label: 'Biaya Lainnya',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      padding: '12px 7px',
    },
    tdClass: 'text-black !py-[9px]',
  },
  {
    key: 'updated_at',
    label: 'tgl pembayaran',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
    },
    tdClass: 'text-black !py-[9px]',
    formatter: value => DAY_MONTH_YEAR(value),
  },
  {
    key: 'disbursement_status',
    label: 'disbursement',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
    },
    tdClass: 'text-black !py-[9px]',
  },
  {
    key: 'action',
    label: 'aksi',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
    },
    tdClass: 'text-black !py-[9px]',
  },
]

export const tableFailedDisburse = [
  {
    key: 'checkbox',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
    },
    tdClass: 'text-black',
  },
  {
    key: 'talent_name',
    label: 'Nama Talent',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
    },
    tdClass: 'text-black',
  },
  {
    key: 'partner_name',
    label: 'Nama Partner',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
    },
    tdClass: 'text-black',
  },
  {
    key: 'invoice_date',
    label: 'Periode',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
    },
    tdClass: 'text-black',
    formatter: value => LABEL_MONTH_YEAR(value),
  },
  {
    key: 'nominal',
    label: 'Nominal',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      textAlign: 'center',
    },
    tdClass: 'text-black',
    formatter: value => IDR(value),
  },
  {
    key: 'status',
    label: 'Disbursement',
    thStyle: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
    },
    tdClass: 'text-black',
    formatter: value => DAY_MONTH_YEAR(value),
  },
]

export const filterOptions = [
  { text: 'Draft', value: 'draft' },
  { text: 'Published', value: 'published' },
  { text: 'Paid', value: 'paid' },
]

export const isEarlyPaymentOptions = [
  {
    label: 'Pembayaran Awal',
    value: true,
  },
  {
    label: 'Pembayaran Akhir',
    value: false,
  },
]

export const roleOptions = [
  { text: 'Customer Service', value: 'Customer Service' },
  { text: 'Admin Marketplace', value: 'Admin Marketplace' },
  { text: 'Advertiser', value: 'Advertiser' },
  { text: 'Livestreamer', value: 'Livestreamer' },
]

export const statusOptions = [
  { text: 'Publish', value: 'publish' },
  { text: 'Paid', value: 'paid' },
  { text: 'Cancelled', value: 'cancelled' },
]

export const tableSharingFee = [
  {
    key: 'no',
    label: 'No',
    class: '',
  },
  {
    key: 'name',
    label: 'Nama Talent',
    class: '',
  },
  {
    key: 'skill_role',
    label: 'Layanan',
    class: '',
  },
  {
    key: 'partner_name',
    label: 'Nama Partner',
    class: '',
  },
  {
    key: 'salary',
    label: 'Gaji Per Talent',
    class: '',
  },
  {
    key: 'amount',
    label: 'Upah Diterima',
    class: '',
  },
  {
    key: 'total',
    label: 'Total Sharing Fee',
    class: '',
  },
]
